import { render, staticRenderFns } from "./CreateMailboxUserDialog.vue?vue&type=template&id=1ab21230&"
import script from "./CreateMailboxUserDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateMailboxUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports